import { useContext, useEffect } from 'react'
import { usePrevious } from 'react-use'
import { updateSentryUserScope } from 'lib/sentry'
import { isEqual } from 'lodash'
import { AuthContext } from 'components/Auth/Auth'

const SentryUpdate = ({ currentUser }) => {
    const prevUser = usePrevious(currentUser)
    const auth = useContext(AuthContext)
    const almaUser = auth?.almaAuthData?.user

    useEffect(() => {
        if (!isEqual(currentUser, prevUser)) {
            updateSentryUserScope(almaUser)
        }
    }, [currentUser, prevUser, almaUser])

    return null
}

export default SentryUpdate
